import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';

import size from 'lodash/size';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'hub-pin-box',
  templateUrl: './pin-box.component.html',
  styleUrls: ['./pin-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PinBoxComponent {
  /** The character value  */
  public char: string = '';

  /** Subscription to animate to asterist */
  private _toAsterisk: Subscription;

  /** Flagger to indicate the component is displaying the asterist */
  public isMasked: boolean = false;

  /** Flagger to indicate the component is marked as invalid  */
  public isInvalid: boolean = false;

  constructor(public changeRef: ChangeDetectorRef) {}

  /**
   * Updates the current character value of the component
   * @param char (Required) The character to set, can be empty ''.
   * @param animate (Required) Flagger to display the character before animating to asterisk
   * @param markAsInvalid (Optional) To mark the component as invalid
   */
  public updateChar(char: string, animate: boolean, markAsInvalid: boolean = false): void {
    if (this._toAsterisk) {
      this._toAsterisk.unsubscribe();
    }

    // Mark the component as invalid
    this.isInvalid = markAsInvalid;

    // Remove the pending animation sub if no character to set
    if (size(char) == 0) {
      this.char = '';
      this.isMasked = false;
      this.changeRef.markForCheck();
      return;
    }

    // set the character
    this.char = char;

    if (animate) {
      this.isMasked = false;

      this._toAsterisk = interval(800).subscribe(() => {
        // if there is still a value
        if (size(this.char)) this.isMasked = true;

        if (this._toAsterisk) this._toAsterisk.unsubscribe();

        this.changeRef.markForCheck();
      });
    } else {
      this.isMasked = true;
    }

    this.changeRef.markForCheck();
  }
}
